import React from 'react';
import { PAGE } from 'common/constants';
import { postMessageToWindow } from '../index';

const FRAME = {
  LAUNCHER_SIZE: {
    WIDTH: '80px',
    HEIGHT: '90px'
  },
  PAGE_WIDTH: '400px',
  PAGE_HEIGHT: '90vh',
  POPUP_WIDTH: '376px',
  POPUP_NEW_MESSAGE: {
    HEIGHT: {
      DEFAULT: '322px',
      EXPANDED: '576px',
    }
  }
}

const iframeStyles = (isMobile, parentFrameSize, metadata, userSettingBot) => {
  const bottomMargin = userSettingBot && userSettingBot.bottomMargin;
  const { shouldNewMessagePopupExpand, isFormFactor } = metadata;
  return {
    [PAGE.LAUNCHER]: `
    height: ${FRAME.LAUNCHER_SIZE.HEIGHT};
    width: ${FRAME.LAUNCHER_SIZE.WIDTH};
    margin-bottom: ${bottomMargin}px;

  `,
    [PAGE.CONVO]: `
      ${
        isMobile
            ? `width: ${parentFrameSize.parentInnerWidth}px;  height: ${parentFrameSize.parentInnerHeight}px;`
            : `width: ${FRAME.PAGE_WIDTH}; height: ${bottomMargin ? `calc(${FRAME.PAGE_HEIGHT} - ${bottomMargin}px)` : `${FRAME.PAGE_HEIGHT}`};`
    }
      margin-bottom: ${bottomMargin}px;
  `,
    [PAGE.DIMMED_CONVO]: `
      ${
        isMobile
          ? `width: ${parentFrameSize.parentInnerWidth}px;  height: ${parentFrameSize.parentInnerHeight}px; box-shadow: 0 0 0 100vmax rgba(0, 0, 0, .5);`
          : `width: ${FRAME.PAGE_WIDTH}; height: ${bottomMargin ? `calc(${FRAME.PAGE_HEIGHT} - ${bottomMargin}px)` : `${FRAME.PAGE_HEIGHT}`}; box-shadow: 0 0 0 100vmax rgba(0, 0, 0, .5);`
      }
      margin-bottom: ${bottomMargin}px;
  `,
    [PAGE.HOME]: `
    ${
      isMobile
        ? `width: ${parentFrameSize.parentInnerWidth}px;  height: ${parentFrameSize.parentInnerHeight}px;`
        : `width: ${FRAME.PAGE_WIDTH}; height: ${bottomMargin ? `calc(${FRAME.PAGE_HEIGHT} - ${bottomMargin}px)` : `${FRAME.PAGE_HEIGHT}`};`
    }
    margin-bottom: ${bottomMargin}px;
  `,
    [PAGE.POPUP_NEW_MESSAGE]: `
    height: ${shouldNewMessagePopupExpand ? FRAME.POPUP_NEW_MESSAGE.HEIGHT.EXPANDED : FRAME.POPUP_NEW_MESSAGE.HEIGHT.DEFAULT };
    ${isMobile ? `width: ${parentFrameSize.parentInnerWidth}px;` : `width: ${FRAME.POPUP_WIDTH};`}
        margin-bottom: ${bottomMargin}px;
  `,
    [PAGE.POPUP_NORMAL]: `
    height: ${isFormFactor ? '250px' : '168px'};
    ${isMobile ? `width: ${parentFrameSize.parentInnerWidth}px;` : `width: ${FRAME.POPUP_WIDTH};`}
        margin-bottom: ${bottomMargin}px;
  `,
    [PAGE.POPUP_CONNECTED]: `
    height: 200px;
    ${isMobile ? `width: ${parentFrameSize.parentInnerWidth}px;` : `width: ${FRAME.POPUP_WIDTH};`}
        margin-bottom: ${bottomMargin}px;
  `,
  };
};

const resizeIframe = (page, type, isMobile, parentFrameSize, metadata, userSettingBot=null) => {
  const event = 'iframe-resize';
  switch (page) {
    case PAGE.LAUNCHER:
      postMessageToWindow({ type, event, style: iframeStyles(isMobile, parentFrameSize, metadata, userSettingBot)[PAGE.LAUNCHER] }, '*');
      break;
    case PAGE.CONVO:
      postMessageToWindow({ type, event, style: iframeStyles(isMobile, parentFrameSize, metadata, userSettingBot)[PAGE.CONVO] }, '*');
      break;
    case PAGE.DIMMED_CONVO:
      postMessageToWindow({ type, event, style: iframeStyles(isMobile, parentFrameSize, metadata, userSettingBot)[PAGE.DIMMED_CONVO] }, '*');
      break;
    case PAGE.HOME:
      postMessageToWindow({ type, event, style: iframeStyles(isMobile, parentFrameSize, metadata, userSettingBot)[PAGE.HOME] }, '*');
      break;
    case PAGE.POPUP_NEW_MESSAGE:
      postMessageToWindow(
          { type, event, style: iframeStyles(isMobile, parentFrameSize, metadata, userSettingBot)[PAGE.POPUP_NEW_MESSAGE] },
          '*'
      );
      break;
    case PAGE.POPUP_CONNECTED:
      postMessageToWindow(
        { type, event, style: iframeStyles(isMobile, parentFrameSize, metadata, userSettingBot)[PAGE.POPUP_CONNECTED] },
        '*'
      );
      break;

    default:
      break;
  }
};

const useResizeIframe = (currentPage, type, callback, parentFrameSize, metadata, userSettingBot = null) => {
  React.useEffect(() => {
    let isMobile = parentFrameSize.parentInnerWidth && parseInt(parentFrameSize.parentInnerWidth) <= 480;
    callback(false);
    resizeIframe(currentPage, type, isMobile, parentFrameSize, metadata, userSettingBot);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, metadata]);
};

export default useResizeIframe;
